import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DictionaryModule } from '@sdbn/common';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProcessSelectionComponent } from './component/process-selection.component';
import { TapableTerminalCardModule } from '../tabbable-terminal-card/tapable-terminal-card.module';
import { CenteredScrollableContentModule } from '../centered-scrollable-content/centered-scrollable-content.module';



@NgModule({
  declarations: [
    ProcessSelectionComponent
  ],
  imports: [
    CommonModule,

    DictionaryModule,
    TapableTerminalCardModule,
    ApplicationClientCommonModule,
    CenteredScrollableContentModule,
    CommonTranslationModule,
    FormsModule,
    ReactiveFormsModule

  ]
})
export class ProcessSelectionModule { }
